export const routes = {
  dashboard: '/',
  assortments: '/assortments',
  assortmentsBranch: '/assortments/branch/:branchId',
  projects: '/projects',
  projectsBranch: '/projects/branch/:branchId',
  project: '/projects/:id',
  assortment: '/assortments/:id',
  users: '/users',
  user: '/users/:id',
  userCustomers: '/userCustomers',
  userCustomersBranch: '/userCustomers/branch/:branchId',
  documents: '/documents',
  notifications: '/notifications',
  updateNotification: '/notifications/:id',
  reports: '/reports',
  branches: '/branches',
  branchesBranch: '/branches/:branchId',
  orders: '/orders',
  ordersBranch: '/orders/branch/:branchId',
  order: '/orders/:id',
  purchases: '/purchases',
  purchasesBranch: '/purchases/branch/:branchId',
  purchase: '/purchases/:id',
  suppliers: '/suppliers',
  suppliersBranch: '/suppliers/branch/:branchId',
  supplier: '/suppliers/:id',
  articles: '/articles',
  articlesBranch: '/articles/branch/:branchId',
  article: '/articles/:id',
  orderRowQueues: '/orderRowQueues',
  orderRowQueuesBranch: '/orderRowQueues/branch/:branchId',
  uploadDocument: '/documents/upload',
  createNotification: '/notifications/create',
  sync: '/sync',
  checkoutAdapters: '/checkoutAdapters',
  checkoutAdaptersAdapter: '/checkoutAdapters/:adapterId',
  customers: '/customers',
  customersBranch: '/customers/branch/:branchId',
  customer: '/customers/:id',
  customerApiKeyLogs: '/customers/:customerId/api-keys/:apiKeyId/logs',
  widgets: '/widgets',
  customsExport: '/customsExport',
  customsExportBranch: '/customsExport/branch/:branchId',
};
